module.exports = __webpack_public_path__ + "img/rosaria.9da9c30f.webp";